<template>
  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.14286 10L0 3V2.38419e-06H14.2857V3L7.14286 10Z"
      fill="currentColor"
    />
  </svg>
</template>
